import * as React from "react";
import { memoization, refs } from "./api-data";
import { GroupContainer, GroupTitle } from "./group-container";
import { Part } from "./part";

const useRef = refs.get("useRef");
const useImpHandle = refs.get("useImperativeHandle");
const forwardRef = refs.get("forwardRef");

const OutsideGroupRight = ({ children }: { children: React.ReactNode }) => (
  <ul className="grid h-full w-full grid-cols-2 grid-rows-2 gap-y-5 gap-x-8 px-5 py-4">
    {children}
  </ul>
);

export function Refs({ scaleItems }) {
  return (
    <GroupContainer>
      <OutsideGroupRight>
        <Part
          data={forwardRef}
          name={"forwardRef"}
          className={"col-start-2 col-end-3 row-start-2"}
          scaleItems={scaleItems}
        />
        <Part
          data={useImpHandle}
          name={"useImperativeHandle"}
          scaleItems={scaleItems}
          className={"col-start-1 col-end-2"}
        />
        <Part
          data={useRef}
          name={"useRef"}
          scaleItems={scaleItems}
          className={"col-start-1 col-end-2 row-start-2"}
        />
      </OutsideGroupRight>
      <GroupTitle>Refs</GroupTitle>
    </GroupContainer>
  );
}

const useMemo = memoization.get("useMemo");
const useCallback = memoization.get("useCallback");
const memo = memoization.get("memo");

export function Memoization({ scaleItems }) {
  return (
    <GroupContainer>
      <OutsideGroupRight>
        <Part
          data={useMemo}
          name={"useMemo"}
          className={"col-start-1 col-end-2"}
          scaleItems={scaleItems}
        />
        <Part
          data={useCallback}
          name={"useCallback"}
          className={"col-start-1 col-end-2"}
          scaleItems={scaleItems}
        />
        <Part
          data={memo}
          name={"memo"}
          className={"col-start-2 col-end-3 row-start-1"}
          scaleItems={scaleItems}
        />
      </OutsideGroupRight>
      <GroupTitle>Memoization</GroupTitle>
    </GroupContainer>
  );
}
